import styled from "styled-components";

const MainContentStyled  = styled.div`
    position: absolute;
    bottom:0;
    padding-top:0px;
    padding-right: 3%;
    padding-left: 0px;
    margin-bottom: 11%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width:100%;
    height:100%;
    z-index:1;
`

export default MainContentStyled;